import React, { useEffect, useState } from "react";
import { getSite, adminUpdateSite } from "@/lib/api";

export default function SiteCopyPage() {
    const [form, setForm] = useState(null);
    const [saving, setSaving] = useState(false);
    const [ok, setOk] = useState(false);

    useEffect(() => {
        getSite().then((d) =>
            setForm({
                about_paragraphs: d.about_paragraphs || [""],
                contact_email: d.contact_email || "",
                linkedin_url: d.linkedin_url || "",
                instagram_url: d.instagram_url || "",
                x_url: d.x_url || "",
            }),
        );
    }, []);

    if (!form)
        return <p className="eyebrow text-[#1B1B1B]/50">Loading…</p>;

    const setPara = (i, v) => {
        const next = [...form.about_paragraphs];
        next[i] = v;
        setForm((f) => ({ ...f, about_paragraphs: next }));
    };
    const addPara = () =>
        setForm((f) => ({
            ...f,
            about_paragraphs: [...f.about_paragraphs, ""],
        }));
    const removePara = (i) =>
        setForm((f) => ({
            ...f,
            about_paragraphs: f.about_paragraphs.filter((_, idx) => idx !== i),
        }));

    const save = async () => {
        setSaving(true);
        setOk(false);
        try {
            const payload = {
                ...form,
                about_paragraphs: form.about_paragraphs.filter((p) => p.trim()),
            };
            await adminUpdateSite(payload);
            setOk(true);
            setTimeout(() => setOk(false), 2500);
        } catch (e) {
            alert("Save failed: " + (e?.response?.data?.detail || e.message));
        } finally {
            setSaving(false);
        }
    };

    return (
        <section data-testid="admin-site-copy">
            <header className="flex items-end justify-between border-b border-[#E6E2D6] pb-6 mb-8">
                <div>
                    <p className="eyebrow text-[#1B1B1B]/60 mb-2">
                        § Copy — 03
                    </p>
                    <h1 className="font-serif-editorial text-4xl md:text-5xl leading-[1.02] tracking-[-0.02em]">
                        Site Copy
                    </h1>
                </div>
                <div className="flex items-center gap-6">
                    {ok && (
                        <span className="eyebrow text-[#A8844F]">Saved</span>
                    )}
                    <button
                        type="button"
                        onClick={save}
                        disabled={saving}
                        data-testid="site-save"
                        className="inline-flex items-center gap-3 px-7 py-3 bg-[#1B1B1B] text-[#F6F3EC] font-sans-tight text-[12px] tracking-[0.2em] uppercase hover:bg-[#A8844F] transition-colors duration-500 disabled:opacity-60"
                    >
                        {saving ? "Saving…" : "Save changes"}
                    </button>
                </div>
            </header>

            <div className="space-y-14 max-w-3xl">
                <section>
                    <h2 className="eyebrow text-[#1B1B1B]/60 mb-4">About</h2>
                    <div className="space-y-4">
                        {form.about_paragraphs.map((p, i) => (
                            <div key={i}>
                                <textarea
                                    rows={4}
                                    className="editorial-input resize-none"
                                    value={p}
                                    onChange={(e) => setPara(i, e.target.value)}
                                    data-testid={`about-para-${i}`}
                                />
                                <div className="text-right mt-1">
                                    <button
                                        type="button"
                                        onClick={() => removePara(i)}
                                        className="eyebrow link-underline text-red-800 text-[10px]"
                                    >
                                        Remove paragraph
                                    </button>
                                </div>
                            </div>
                        ))}
                        <button
                            type="button"
                            onClick={addPara}
                            className="eyebrow link-underline"
                        >
                            + Add paragraph
                        </button>
                    </div>
                </section>

                <section>
                    <h2 className="eyebrow text-[#1B1B1B]/60 mb-4">Contact</h2>
                    <label className="eyebrow text-[#1B1B1B]/60">
                        Public contact email
                    </label>
                    <input
                        className="editorial-input"
                        value={form.contact_email}
                        onChange={(e) =>
                            setForm({ ...form, contact_email: e.target.value })
                        }
                        data-testid="site-contact-email"
                    />
                </section>

                <section className="space-y-4">
                    <h2 className="eyebrow text-[#1B1B1B]/60 mb-4">Socials</h2>
                    <div>
                        <label className="eyebrow text-[#1B1B1B]/60">LinkedIn</label>
                        <input
                            className="editorial-input"
                            value={form.linkedin_url}
                            onChange={(e) =>
                                setForm({ ...form, linkedin_url: e.target.value })
                            }
                            data-testid="site-linkedin"
                        />
                    </div>
                    <div>
                        <label className="eyebrow text-[#1B1B1B]/60">Instagram</label>
                        <input
                            className="editorial-input"
                            value={form.instagram_url}
                            onChange={(e) =>
                                setForm({ ...form, instagram_url: e.target.value })
                            }
                            data-testid="site-instagram"
                        />
                    </div>
                    <div>
                        <label className="eyebrow text-[#1B1B1B]/60">X (Twitter)</label>
                        <input
                            className="editorial-input"
                            value={form.x_url}
                            onChange={(e) =>
                                setForm({ ...form, x_url: e.target.value })
                            }
                            data-testid="site-x"
                        />
                    </div>
                </section>
            </div>
        </section>
    );
}
